/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import store from "@/store";
import {
  CORE_ALERT_ENABLED,
  CORE_CONNECT_ENABLED,
  CORE_COMMUNICATOR_ENABLED,
  CONVEY_COMMUNICATOR,
  CONVEY_ALERT,
  CONVEY_CONNECT,
} from "../constants";

export const moduleGuard = (moduleName) => {
  return async (to, from, next) => {
    const fn = async () => {
      const currentAgency = store.getters['agency/currentAgency'];
      const currentUser = store.getters['user/currentUser'];
      const currentToken = store.getters['user/currentToken'];
      const currentSession = store.getters['user/currentSession'];
      if (currentUser && currentSession) {
        if (currentAgency) {
          if (currentAgency.settings) {
            if (!moduleName) {
              next();
            } else if (currentAgency.settings[moduleName]) {
              const agencyId = currentAgency.agency_id;
              let selectedModule = null;
              if (moduleName === CORE_COMMUNICATOR_ENABLED) {
                selectedModule = CONVEY_COMMUNICATOR;
              } else if (moduleName === CORE_ALERT_ENABLED) {
                selectedModule = CONVEY_ALERT;
              } else if (moduleName === CORE_CONNECT_ENABLED) {
                selectedModule = CONVEY_CONNECT;
              }
              store.commit("agency/setLastSelectedModule", { agencyId, module: selectedModule });
              next();
            } else {
              next('/404');
            }
          }
        } else {
          let agencyId = null;
          if (Vue.prototype.$cookie.get("x-current-agency") && currentUser.agencies.find(el => el.agency_id === Vue.prototype.$cookie.get("x-current-agency")))
            agencyId = Vue.prototype.$cookie.get("x-current-agency");
          else if (currentUser.default_agency && currentUser.default_agency.agency_id)
            agencyId = currentUser.default_agency.agency_id;
          else if (currentUser.agencies.length == 1)
            agencyId = currentUser.agencies[0].agency_id;

          if (!agencyId || agencyId.length != 36) {
            if (!currentUser.agencies || currentUser.agencies.length === 0) {
              if (to.path !== '/') {
                const commonModuleRoutes = ["User Profile"];
                if (commonModuleRoutes.includes(to.name)) {
                  next();
                } else {
                  next('/');
                }
              } else {
                next();
              }
            } else {
              const commonModuleRoutes = ["User Profile"];
              if (commonModuleRoutes.includes(to.name)) {
                next();
              } else if (to.path !== '/') {
                next('/404');
              } else {
                next();
              }
            }
          } else {
            try {
              const headers = {
                Authorization: `Bearer ${currentToken}`,
                "Content-Type": "application/json",
              };
  
              let customTenantUrl = '';
              const resp = await axios.get(`${Vue.prototype.$apihost}/agencies/${agencyId}`, { headers });
              const { settings } = resp.data.data;
              
              if (settings['agencyTenantUrl'] !== 'null') {
                customTenantUrl = settings['agencyTenantUrl']
              }
              
              if (customTenantUrl && ![window.location.host, window.location.origin].includes(customTenantUrl)) {
                const rsosToken = Vue.prototype.$cookie.get("x-rsos-token");
                window.location = `${customTenantUrl}?agency_id=${agencyId}${rsosToken ? `rsos_token=${rsosToken}` : ''}`;
                return;
              }
              await store.dispatch("agency/bindAgencySession", { agencyId, sessionId: currentSession });
              Vue.prototype.$toastr("success", `Welcome back, ${currentUser.fname}`);
              fn();
            } catch(err) {
              next('/404');
            }
          }
        }
      } else {
        setTimeout(() => {
          fn();
        }, 500);
      }
    };
    fn();
  };
};